module.exports = __webpack_public_path__ + "static/media/bars45large.c294f971.png";